import React, { useState } from "react";
import { observer } from "mobx-react";
import { FiType } from "react-icons/fi";
import CurriculumStore from "../../../../stores/CurriculumStore";
import { Button, Input, Spinner } from "../../../-common";
import "./UpdateDetailsModal.scss";

function UpdateDetailsModal({ album, close }) {
  const { title: currentTitle } = album || {};

  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState(currentTitle);
  const updateTitle = ({ target }) => setTitle(target.value);

  const trimmedTitle = title?.trim();
  const hasTitle = !!trimmedTitle;
  const changed = trimmedTitle !== currentTitle;
  const updateEnabled = hasTitle && changed;
  const updateAlbum = async () => {
    if (updateEnabled) {
      setLoading(true);
      const updates = { title: trimmedTitle };
      const updatedAlbum = await CurriculumStore?.updateAlbum(album?.id, updates);
      setLoading(false);
      if (updatedAlbum) close();
    }
  };

  const cancelButtonStyles = loading ? { opacity: 0.1, pointerEvents: "none" } : {};

  const actionButtonStyles = updateEnabled
    ? loading
      ? { opacity: 0.3, pointerEvents: "none" }
      : {}
    : { opacity: 0.3, pointerEvents: "none" };
  const actionButtonContent = loading ? <Spinner /> : "Update Details";

  return (
    <div className="update-album-details-modal">
      <div className="content">
        <div className="title">Update Album Details</div>
        <div className="section-container">
          <div className="section-title">Title</div>
          <Input icon={FiType} placeholder="Album Title" value={title} onChange={updateTitle} />
        </div>
      </div>
      <div className="bottom-buttons">
        <Button action={close} style={cancelButtonStyles}>
          Cancel
        </Button>
        <div className="left-buttons">
          <Button type="primary" action={updateAlbum} style={actionButtonStyles}>
            {actionButtonContent}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default observer(UpdateDetailsModal);
